import { Modal, Button } from "react-bootstrap";

export default function DeleteConfirmationModel({
  open,
  handleClose,
  onConfirm,
  message,
}) {
  return (
    <Modal show={open} onHide={handleClose} centered size="sm">
      <Modal.Header closeButton>
        <Modal.Title className="w-100 text-center">Confirm Delete</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <p>{message || "Are you sure you want to delete this record?"}</p>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button variant="secondary" onClick={handleClose}>
          No
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Yes, Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
